import { faClose, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useRef } from 'react';

export type EditarElementoProps = {
	title: string;
	children: React.ReactNode;
	titleButton: string;
	open?: boolean;
	onSwitchOpen: (value:boolean) => void;
}

const EditarElementoModal: React.FC<EditarElementoProps> = ({ title, children, titleButton, open, onSwitchOpen }) => {

	const ref = useRef<HTMLDialogElement>(null);

	const openModal = useCallback(() => {
		ref.current?.showModal();
	}, [ref]);

	const closeModal = useCallback(() => {
		ref.current?.close();
	}, [ref]);

	React.useEffect(()=> {
		if(open) {
			ref.current?.showModal();
		} else {
			ref.current?.close();
		}
	}, [open]);

	return (
		<dialog id="modal-dialog" ref={ref} className='modal-box text-center'>
			<h1 className="text-lg font-bold">{title}</h1>
			<button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" onClick={()=>onSwitchOpen(false)}>
				<FontAwesomeIcon icon={faClose}/>
			</button>
			{children}
		</dialog>
	)
};

export default EditarElementoModal;
